import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { useDispatch, useSelector } from 'react-redux';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Checkbox, TextField } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import IndexedDBService, { keyboardSettings } from '../../Utils/DBConfig';
import { setKeyboardKeys } from '../../Slice/keyBoardSlice';

const CustomTable = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const keyboardKeys = useSelector((state) => state.keyboardSlice.keyboardKeys);
    const [rows, setRows] = React.useState([]);

    React.useEffect(() => {
        if (keyboardKeys.length > 0) {
            setRows(keyboardKeys);
        }
    }, [keyboardKeys]);

    const handleApiChange = (e, id, field) => {
        const { value } = e.target;
        setRows(prevRows =>
            prevRows.map(row =>
                row.id === id ? { ...row, [field]: { ...row[field], api: value } } : row
            )
        );
    };

    const handleCheckboxChange = (e, id, field) => {
        const { checked } = e.target;
        setRows(prevRows =>
            prevRows.map(row =>
                row.id === id ? { ...row, [field]: { ...row[field], flag: checked } } : row
            )
        );
    };

    const handleBackToHome = () => {
        rows.forEach((button) => {
            let obj = { ...button };
            IndexedDBService.updateItem(obj, keyboardSettings)
                .then(() => { })
                .catch(() => { })
                .finally(() => { });
        });
        dispatch(setKeyboardKeys(rows));
        navigate('/');
    };

    return (
        <>
            <button className="absolute top-1 right-2 px-1 pb-1 text-xl bg-red-600 text-white rounded-full" onClick={handleBackToHome}><ArrowBackIcon /></button>
            <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell sx={{ border: '1px solid rgba(224, 224, 224, 1)' }}>Id</TableCell>
                            <TableCell align="center" sx={{ border: '1px solid rgba(224, 224, 224, 1)' }}>Get (v-mix)</TableCell>
                            <TableCell align="center" sx={{ border: '1px solid rgba(224, 224, 224, 1)' }}>Get (v-mix)</TableCell>
                            <TableCell align="center" sx={{ border: '1px solid rgba(224, 224, 224, 1)' }}>Get (v-mix)</TableCell>
                            <TableCell align="center" sx={{ border: '1px solid rgba(224, 224, 224, 1)' }}>post (companion)</TableCell>
                            <TableCell align="center" sx={{ border: '1px solid rgba(224, 224, 224, 1)' }}>post (companion)</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rows && rows.map((row) => (
                            <TableRow
                                key={row.id}
                            >
                                <TableCell component="th" scope="row" sx={{ border: '1px solid rgba(224, 224, 224, 1)' }}>
                                    {row.id}
                                </TableCell>
                                {['get1', 'get2', 'get3', 'post1', 'post2'].map(field => (
                                    <TableCell key={field} align="center" sx={{ border: '1px solid rgba(224, 224, 224, 1)' }}>
                                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                            <Checkbox
                                                checked={row[field].flag}
                                                onChange={(event) => handleCheckboxChange(event, row.id, field)}
                                            />
                                            <TextField
                                                value={row[field].api}
                                                onChange={(event) => handleApiChange(event, row.id, field)}
                                                size="small"
                                                variant="outlined"
                                                style={{ marginLeft: 8 }}
                                            />
                                        </div>
                                    </TableCell>
                                ))}
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </>
    );
};

export default CustomTable;
